import { connect } from 'react-redux'
import { getUserRole } from '../../../redux/user/selectors'
import PageNotFound from '../../../components/PageNotFound'

const mapStateToProps = (state) => ({
  userRole: getUserRole(state),
})

export default connect(mapStateToProps, null)(PageNotFound)
